<template>
	<div class="login">
		<div class="login-container">
			<p class="title">南外人考试系统</p>
			<a v-if="exam" :href="`/exam/${exam}`">最近参加的考试</a>
			<template v-if="papers">
				<a v-for="paper in papers" :href="`/exam/${paper.key ? paper.key : paper.id}`">{{paper.title}}</a>
			</template>
			<a @click="logout()" style="color: red;border-color: #ff00004a;border-color: rgba(255, 0, 0, 0.3);">退出</a>
		</div>
	</div>
</template>

<script>
	import Vue from 'vue';
    import {clearLocalStorage, clearSessionStorage, getLocalStorage, getStorage} from "../utils/cookie";
    import {GET_PAPERS} from "../utils/dataProvider";
    import mixins_config from "@/mixins/config.js";

    export default {
        name: "Home",
        mixins: [mixins_config],
        data() {
            return {
                exam: null,
                papers: null,
            }
        },
        mounted() {
            // console.log('Login mounted');

            let isLogin = Vue.permanentAuth ? !!getLocalStorage("token") : !!getStorage("token")
            if (!isLogin) {
                this.$router.push({
                    name: "Login"
                })
            }
            
            let exam = getLocalStorage('exam');
            if (!!exam) {
                this.exam = exam;
            }
            if (this.isLogin) {
                this.getPapers();
            }
        },
        methods: {
            getPapers() {
                let that = this;

                return GET_PAPERS(function (res) {
                    if (!res.data || res.data.length <= 0 || !(res.data[0].hasOwnProperty('status'))) {
                        return
                    }
					that.papers = res.data;
                })
            },
            logout() {
                clearSessionStorage('token');
                clearLocalStorage('token');
                this.$router.push({
                    name: 'Login'
                })
            },
        }
    }
</script>

<style scoped>

</style>